import { StatePropertyRef } from '../../canvas/ExtendableStore';

export interface FollowingInfo {
    userId?: string;
}

export const FollowingInfo = StatePropertyRef<FollowingInfo>('following', { userId: null });
